import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

export function OrderBasedKpiNote() {
  return (
    <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', fontWeight: 300 }}>
      <FormattedMessage id="info.content.order-based.measures" />
    </Typography>
  );
}
